import { render, staticRenderFns } from "./report-form.vue?vue&type=template&id=f85993c4&scoped=true&"
import script from "./report-form.vue?vue&type=script&lang=js&"
export * from "./report-form.vue?vue&type=script&lang=js&"
import style0 from "./report-form.vue?vue&type=style&index=0&id=f85993c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85993c4",
  null
  
)

export default component.exports